import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
} from "../../../../usecases/object";
import { Button, InfiniteScroll, Progress } from "nq-component";
import TimeSheetPresenter from "./TimeSheetPresenter";
import CardView from "../../../../components/common/CardView";
import Table from "../../../../components/Table";
import PrintDTR from "../../../EmployeeSelfService/TimeManagement/time-management-table/print/PrintDTR";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import FormFactory from "../../../../components/FormFactory";
import { FloatingForm } from "../../../../components/common/Converter";
import TimeFormPage from "../../../EmployeeSelfService/TimeManagement/time-management-table/time-form/TimeFormPage";
import InputFactory from "../../../../components/InputFactory";
import timesheetSchema from "./timesheet_schema.json";
import UpdateLogSchedule from "./UpdateLogSchedule";

export default class TimeSheetTable extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TimeSheetPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
    );
    this.state = {
      objects: [],
      object: {},
      count: 0,
      limit: 50,
      current: 1,
      availableMonth: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      // month: "December",
      // year: 2025,
    };
  }

  getCollectionName() {
    return "biometric_logs";
  }
  setObjects(objects) {
    this.setState({ objects });
  }

  async handleDeleteData(id) {
    this.navigateTo(`/schema`);
  }

  handleViewObject(object) {
    this.setState({ isViewObject: true, object });
  }

  async onChangeForm(field, value) {
    this.setState({ [field]: value });
    this.onChangeFilter("Boolean", value, field);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = timesheetSchema;
    const {
      count,
      progress,
      current,
      limit,
      objects,
      employee,
      month,
      year,
      availableMonth,
      isLoading,
    } = this.state;
    if (!schema) return <Progress />;
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

    const currentUser = this.getCurrentUser();
    const isCheckerRole = currentUser?.roles?.some(
      (role) => role?.id?.toLowerCase()?.trim() === "checker",
    );
    // const isCheckerRole = true;
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "1rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="">
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex gap-2">
                  <SearchSelect
                    focus={true}
                    style={{ border: "1px solid #ccc", borderRadius: "4px" }}
                    value={this.state.month || ""}
                    placeholder="Month"
                    onClickClear={() => this.onChangeForm("month", "")}
                    onChange={(value) => this.onChangeForm("month", value)}
                    options={this.state.availableMonth.map((month) => ({
                      label: month,
                      value: month,
                    }))}
                  />
                  <SearchSelect
                    focus={true}
                    value={this.state.year || ""}
                    placeholder="Year"
                    onClickClear={() => this.onChangeForm("year", "")}
                    onChange={(value) => this.onChangeForm("year", value)}
                    options={years.map((year) => ({
                      label: year.toString(),
                      value: year.toString(),
                    }))}
                  />

                  <InputFactory
                    type="Pointer"
                    target="employees"
                    include={["employmentType"]}
                    // where={{ id: "69f67e38-b374-42da-8510-8d661b5110b2" }}
                    keys={[
                      "biometricId",
                      // "selectedSchedule.startingDate",
                      // "selectedSchedule.scheduleArray",
                      // "selectedSchedule.selectedOption",
                      // "selectedSchedule.sequence",
                      "agency",
                      "Firstname",
                      "Middlename",
                      "surname",
                      "region",
                      "office",
                      "division",
                      "section",
                      "unit",
                      "cluster",
                      "twentyFourSeven",
                      "employmentType.name",
                    ]}
                    onChange={(value) => {
                      this.setState({ employee: value });
                      this.onChangeFilter("Boolean", value, "employee");
                    }}
                  />
                  <Button onClick={() => this.presenter.handleSearchSubmit()}>
                    Search
                  </Button>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary me-auto">{schema.label}</h4>
                    <div
                      className="d-flex gap-2"
                      style={{ marginLeft: "auto" }}
                    >
                      {isCheckerRole && (
                        <Button
                          onClick={() =>
                            this.presenter.handleUpdateLogSched(
                              objects,
                              month,
                              year,
                            )
                          }
                          disabled={objects.length === 0}
                        >
                          Update Schedule
                        </Button>
                      )}
                      {!isCheckerRole && (
                        <Button
                          onClick={() =>
                            this.presenter.handleTimeOff(objects, month, year)
                          }
                          disabled={objects.length === 0}
                        >
                          Time Off
                        </Button>
                      )}

                      <Button onClick={() => this.setState({ printDTR: true })}>
                        Print DTR
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                currectRoles={this.getCurrentRoles()?.some(
                  (role) => role.id === "Event Logs",
                )}
                // currectRoles={true}
                viewObject={this.handleViewObject.bind(this)}
                objectId={this.handleDeleteData.bind(this)}
                hrAction={(data) => this.presenter.handleEditData(data)}
                // slide
                payslip={this.presenter.confirmationSlideDialog.bind(this)}
                progress={isLoading}
                refetch={this.presenter.handleSearchSubmit.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "daily_time_record",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["APlateMinutes", "APundertimeMinutes",
                  //   "timeAmOutMode",
                  // "timeInMode",
                  // "timeOutMode",
                  // "timePmInMode"
                  ],
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.printDTR && (
          <PrintDTR
            closeAccess={() => this.setState({ printDTR: false })}
            dailyRec={objects}
            employee={employee}
            month={month}
            year={year}
            availableMonth={availableMonth}
          />
        )}

        {this.state.isViewObject && (
          <FloatingForm width="60rem">
            <CardView style={{ padding: 0 }}>
              <h4 className="fs-6 fw-bold pt-3 ps-3">View Details</h4>
              <hr />
              <div className="row pe-5 ps-5">
                <FormFactory
                  className="col-lg-6 p-1 mt-2"
                  schema={schema}
                  disabled
                  object={this.state.object}
                />
              </div>
              <hr />
              <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                <Button
                  className="btn btn-light fs-sm"
                  onClick={() =>
                    this.setState({ isViewObject: false, object: {} })
                  }
                >
                  Cancel
                </Button>
              </div>
            </CardView>
          </FloatingForm>
        )}
        {this.state.timeForm && (
          <TimeFormPage
            handleCloseForm={() => this.setState({ timeForm: false })}
            objectData={this.state.objectData}
            employee={employee}
            refetchData={() => this.presenter.handleSearchSubmit()}
          />
        )}
        {this.state.updateLogSched && (
          <UpdateLogSchedule
            obejcts={objects}
            minDate={this.state.minDate}
            maxDate={this.state.maxDate}
            employee={employee}
            closeDialog={() => this.setState({ updateLogSched: false })}
          />
        )}
      </>
    );
  }
}
